<div class="loader">
    <div></div>
    <div></div>
    <div></div>
</div>
<span class="sr-only">{{ 'loading' | translate }}</span>
